export default __webpack_public_path__ + "static/media/bridge-white.ab65b928.svg";